import React, { useEffect, useRef } from 'react';
import Heading from '@legacy-vfuk/core-heading';
import { GatsbyImage } from 'gatsby-plugin-image';
import {
  IArticle,
  UiImageNoResultsFound,
} from './types/SectionFilterableArticles.types';
import {
  noResultDescriptionStyles,
  noResultImageStyles,
} from './styles/SectionFilterableArticle.styles';
import { ArticleCard } from '../../Elements/ArticleCard';
import { ArticleCardGridContainer } from './styles/ArticleCardGrid.styles';

type DisplayListOfArticlesProps = {
  articles: IArticle[];
  articleCardProps: {
    indexSlug: string;
    backgroundColor: 'white';
    seoTitle: string;
    appliedFilters: any;
    queryCategories: string[];
    readingTimeMinuteLabel: string;
    displaySaveIcon: boolean;
    saveLabelText: string;
    handleSaveClick: () => void;
    isAnimated: boolean;
  };
  noResultData: {
    uiImageNoResultsFound: UiImageNoResultsFound | undefined;
    uiTextNoResults: string;
    uiTextNoResultsDescription: string;
  };
};

const ArticleCardGrid: React.FC<DisplayListOfArticlesProps> = ({
  articles,
  articleCardProps: {
    indexSlug,
    seoTitle,
    appliedFilters,
    queryCategories,
    readingTimeMinuteLabel,
    displaySaveIcon,
    saveLabelText,
    handleSaveClick,
    isAnimated,
  },
  noResultData: {
    uiImageNoResultsFound,
    uiTextNoResults,
    uiTextNoResultsDescription,
  },
}) => {
  const hasHydrated = useRef(false);

  useEffect(() => {
    hasHydrated.current = true;
  }, []);

  if (hasHydrated.current && articles.length === 0) {
    return (
      <>
        {uiImageNoResultsFound && (
          <GatsbyImage
            image={uiImageNoResultsFound.gatsbyImageData}
            css={noResultImageStyles}
            alt="No results found"
          />
        )}

        <Heading level={5} justify="center">
          <b>{uiTextNoResults}</b>
        </Heading>

        <p css={noResultDescriptionStyles}>{uiTextNoResultsDescription}</p>
      </>
    );
  }

  return (
    <ArticleCardGridContainer>
      {articles.map(article => (
        <div key={article.id}>
          <ArticleCard
            isFeatured={false}
            indexSlug={indexSlug}
            backgroundColor={'white'}
            data={article}
            viewCount={article.viewCount}
            seoTitle={seoTitle}
            appliedFilters={appliedFilters}
            queryCategories={queryCategories}
            readingTimeMinuteLabel={readingTimeMinuteLabel}
            displaySaveIcon={displaySaveIcon}
            saveLabelText={saveLabelText}
            handleSaveClick={handleSaveClick}
            isAnimated={isAnimated}
          />
        </div>
      ))}
    </ArticleCardGridContainer>
  );
};

export default ArticleCardGrid;
